module.exports = __webpack_public_path__ + "files/16b4cb8642ca6f4925af63a3e0d125ca.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/pdf.png
// module id = 312
// module chunks = 60